import { all } from 'redux-saga/effects'

import { organizationDetailsModalSaga } from '../components/OrganizationDetailsModal/duck/operations'
import { dataSaga } from '../data/operations'
import { dealManagerSaga } from '../scenes/DealManager/duck/operations'
import { organizationsManagerSaga } from '../scenes/OrganizationsManager/duck/operations'
import { peopleManagerSaga } from '../scenes/PeopleManager/duck/operations'

export function* dashboardSaga() {
  yield all([
    dataSaga(),
    organizationsManagerSaga(),
    organizationDetailsModalSaga(),
    peopleManagerSaga(),
    dealManagerSaga(),
  ])
}
